<template>
  <div>
    <navTitle><div class="pageTitle">相关学会资讯</div></navTitle>
    <div v-if="dataList.length" class="officeList">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
        :offset="10"
      >
        <div class="newsList">
          <div
            class="news flex flex-align-center flex-jus-between"
            v-for="item in dataList"
            :key="item.id"
            @click="toDetail(item)"
          >
            <img :src="item.pic" class="img" />
            <div class="content flex-1 flex flex-column flex-jus-between">
              <div class="cotent-title no-wrap-2">{{ item.title }}</div>
              <div class="content-time">
                {{ item.create_time | formatDate_noS }}
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="empty" v-if="dataList.length == 0">
			<div class="empty-img">
				<img src="@/static/images/index/emptySearch.png" alt="">
			</div>
			<div class="empty-text">暂无资讯</div>
		</div>
  </div>
</template>

<script>
import navTitle from "@/views/components/navTitle.vue";
/* eslint-disable */
export default {
  components: {
    navTitle,
  },
  data() {
    return {
      page: 1,
      loading: false,
      finished: false,
      dataList: [],
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '相关学会资讯',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
  },
  methods: {
    getList() {
      this.$get("api/actile/getNewsList", {
        pageSize: 10,
        page: this.page,
      }).then((res) => {
        this.loading = false;
        let rows = res.data;
        if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
        this.dataList = this.dataList.concat(rows);

      });
    },
    onLoad() {
      this.page++;
      if (this.page > 1) {
        this.getList();
      }
    },
    toDetail(data) {
      if (data.is_link == 1) {
        location.href = data.link
        return
      }
      this.$router.push({ name: 'news_details', query: { id: data.id } })
    }
  },
};
</script>

<style scoped lang="stylus">
.pageTitle {
  width: 100%;
  text-align: center;
  font-size: 34px;
  font-weight: 500;
  color: #FFFFFF;
}
</style>
<style scoped lang="stylus">
.newsList {
  padding 0 30px;
}
.news {
  margin-top: 28px;
  width: 100%;
  height: 180px;
}
.img {
  width: 272px;
  height: 180px;
  border-radius: 10px;
}
.content {
  height: 180px;
  margin-left: 24px;
}
.cotent-title {
  font-size: 30px;
  font-weight: bold;
  color: #111;
}
.content-time {
  font-size: 26px;
  color: #b1b1b1;
}
.empty
	background-color inherit
	.empty-img
		margin 280px auto 0 auto
		width 373px
		height 320px
		img
			width 100%
			height 100%
	.empty-text
		width 100%
		text-align center
		margin-top 22px
		font-size: 26px;
		color: #111111;
</style>
